import { FC } from 'react';

import { ReactComponent as Radio } from 'assets/icons/checkbox/radio.svg';
import { ReactComponent as Unchecked } from 'assets/icons/checkbox/unchecked.svg';

import styles from './PhotoPosition.module.scss';
import { useField } from 'formik';

export enum PhotoPositionEnum {
	Contain = 'contain',
	Cover = 'cover',
}

const PhotoPositionTitles = {
	[PhotoPositionEnum.Contain]: 'Contain',
	[PhotoPositionEnum.Cover]: 'Cover',
};

const PhotoPosition: FC<{ name: string }> = ({ name }) => {
	const [field, meta, form] = useField(name);

	const handleChangePhotoPosition = (position: PhotoPositionEnum) => {
		form.setValue(position).finally();
	};

	return (
		<div className={styles.photoPosition}>
			<span className={styles.photoPosition_label}>Photo Position</span>
			<div className={styles.photoPosition__items}>
				<div
					className={styles.photoPosition__items_item}
					onClick={() => handleChangePhotoPosition(PhotoPositionEnum.Contain)}
				>
					{field.value === PhotoPositionEnum.Contain ? <Radio /> : <Unchecked />}

					<span className={styles.photoPosition__items_item_label}>
						{PhotoPositionTitles[PhotoPositionEnum.Contain]}
					</span>
				</div>
				<div
					className={styles.photoPosition__items_item}
					onClick={() => handleChangePhotoPosition(PhotoPositionEnum.Cover)}
				>
					{field.value === PhotoPositionEnum.Cover ? <Radio /> : <Unchecked />}
					<span className={styles.photoPosition__items_item_label}>
						{PhotoPositionTitles[PhotoPositionEnum.Cover]}
					</span>
				</div>
			</div>
		</div>
	);
};

export default PhotoPosition;
